import { useState } from 'react';
import { salesService, CreateSaleDto, Sale } from '../services/salesService';

export const useSales = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sales, setSales] = useState<Sale[]>([]);

  const createSale = async (saleData: CreateSaleDto) => {
    setLoading(true);
    setError(null);
    try {
      const result = await salesService.createSale(saleData);
      setLoading(false);
      return result;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Une erreur est survenue');
      setLoading(false);
      throw err;
    }
  };

  const getSales = async (companyId: string) => {
    setLoading(true);
    setError(null);
    try {
      const result = await salesService.getSales(companyId);
      setSales(result);
      setLoading(false);
      return result;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Une erreur est survenue');
      setLoading(false);
      throw err;
    }
  };

  return {
    createSale,
    getSales,
    sales,
    loading,
    error
  };
};

export default useSales;
